import useTranslation from 'customHooks/translate';

const InvoiceLineInfo = ({ currencyId, invoiceLines, sendInvoiceLine }) => {
  const translation = useTranslation();

  return (
    <div className="flex h-full flex-col gap-[10px] px-[16px] py-[24px] md:border-l md:border-l-[#f5f7f9]">
      <div className="flex h-max flex-col justify-between gap-[4px] rounded-[4px] bg-[#F5F7F9] p-[16px]">
        <p className="text-[18px] font-semibold text-[#1D1D1D]">
          {translation.InvoiceLine.InvoiceDetails}
        </p>
        <div className="flex items-center gap-[6px]">
          <p className="text-[16px] font-medium text-[#1D1D1D]">
            {translation.InvoiceLine.Total}:
          </p>
          <p className="text-[16px] font-normal text-[#1D1D1D]">
            {invoiceLines?.total} {currencyId}
          </p>
        </div>
        <div className="flex items-center gap-[6px]">
          <p className="text-[16px] font-medium text-[#1D1D1D]">
            {translation.InvoiceLine.Discount}:
          </p>
          <p className="text-[16px] font-normal text-[#1D1D1D]">
            {invoiceLines?.discount} {currencyId}
          </p>
        </div>
        <div className="flex items-center gap-[6px]">
          <p className="text-[16px] font-medium text-[#1D1D1D]">
            {translation.InvoiceLine.Tax}:
          </p>
          <p className="text-[16px] font-normal text-[#1D1D1D]">
            {invoiceLines?.tax}
            {currencyId}
          </p>
        </div>
        <div className="flex items-center gap-[6px]">
          <p className="text-[16px] font-medium text-[#1D1D1D]">
            {translation.InvoiceLine.Summary}:
          </p>
          <p className="text-[16px] font-normal text-[#1D1D1D]">
            {invoiceLines?.summary} {currencyId}
          </p>
        </div>
      </div>
      <button
        onClick={sendInvoiceLine}
        className="flex items-center justify-center gap-[6px] rounded-[6px] rounded-[6px] bg-green-600 px-[12px] py-[8px] text-[14px] font-normal leading-[16px] text-white transition-all duration-300 ease-in-out hover:bg-green-500 md:px-[24px]"
      >
        {translation.InvoiceLine.Finish}
      </button>
    </div>
  );
};

export default InvoiceLineInfo;
